import React from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Typography,
} from "@mui/material";
import { useAuth } from "../contexts/AuthContext";
import ThemeModeToggle from "../components/layout/ThemeModeToggle";

const OrgSignupConfirmationPage: React.FC = () => {
  const { orgSignupResult, logout } = useAuth();

  if (!orgSignupResult) {
    return null;
  }

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        bgcolor: "background.default",
        py: 4,
        position: "relative",
      }}
    >
      <Box sx={{ position: "absolute", top: 16, right: 16 }}>
        <ThemeModeToggle />
      </Box>
      <Container maxWidth="sm">
        <Card variant="outlined" sx={{ borderRadius: 2 }}>
          <CardContent sx={{ p: 4 }}>
            <Typography variant="h5" fontWeight={700} gutterBottom>
              Organization created
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              Your organization has been registered successfully. Sign out and
              sign in again to access it.
            </Typography>

            <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, mb: 3 }}>
              <Typography variant="body2">
                <strong>Organization ID:</strong> {orgSignupResult.tenantId}
              </Typography>
              <Typography variant="body2">
                <strong>Preferred org name:</strong>{" "}
                {orgSignupResult.preferredOrgName}
              </Typography>
              <Typography variant="body2">
                <strong>Company name:</strong> {orgSignupResult.companyName}
              </Typography>
              <Typography variant="body2">
                <strong>Administrator email:</strong> {orgSignupResult.adminEmail}
              </Typography>
            </Box>

            <Button
              variant="contained"
              fullWidth
              sx={{ textTransform: "none", fontWeight: 600 }}
              onClick={() => void logout()}
            >
              Sign out and sign in again
            </Button>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
};

export default OrgSignupConfirmationPage;
